import React from 'react';
import PageHeader from '../components/shared/PageHeader';
import AnimatedSection from '../components/ui/AnimatedSection';
import Seo from '../components/shared/Seo';
import PageExtras from '../components/shared/PageExtras';
import { useTranslation, Trans } from 'react-i18next';

const PrivacyPolicyPage: React.FC = () => {
    const { t } = useTranslation('common');
    const informationList = t('privacyPolicyPage.informationList', { returnObjects: true }) as string[];
    const useOfInformationList = t('privacyPolicyPage.useOfInformationList', { returnObjects: true }) as string[];

    return (
        <>
            <Seo
                title={t('privacyPolicyPage.seoTitle')}
                description={t('privacyPolicyPage.seoDescription')}
            />
            <div>
                <PageHeader
                    title={t('privacyPolicyPage.pageTitle')}
                    subtitle={t('privacyPolicyPage.pageSubtitle')}
                    imageUrl="https://images.pexels.com/photos/3228884/pexels-photo-3228884.jpeg?auto=compress&cs=tinysrgb&w=1600&fm=webp"
                />
                <AnimatedSection className="py-24">
                    <div className="mx-auto max-w-3xl px-6 prose prose-invert prose-lg text-white/90">
                        <h2>{t('privacyPolicyPage.introductionTitle')}</h2>
                        <p>{t('privacyPolicyPage.introductionParagraph')}</p>
                        
                        <h2>{t('privacyPolicyPage.informationTitle')}</h2>
                        <p>{t('privacyPolicyPage.informationParagraph')}</p>
                        <ul>
                            {informationList.map((item, index) => (
                                <li key={index}>
                                    <Trans
                                        i18nKey={`privacyPolicyPage.informationList.${index}`}
                                        t={t}
                                        components={{ bold: <strong /> }}
                                    />
                                </li>
                            ))}
                        </ul>
                        
                        <h2>{t('privacyPolicyPage.useOfInformationTitle')}</h2>
                        <p>{t('privacyPolicyPage.useOfInformationParagraph')}</p>
                        <ul>
                           {useOfInformationList.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>

                        <h2>{t('privacyPolicyPage.securityTitle')}</h2>
                        <p>{t('privacyPolicyPage.securityParagraph')}</p>

                        <h2>{t('privacyPolicyPage.contactTitle')}</h2>
                        <p>{t('privacyPolicyPage.contactParagraph')}</p>
                    </div>
                </AnimatedSection>
                <PageExtras pageKey="privacy" />
            </div>
        </>
    );
};

export default PrivacyPolicyPage;